import { render } from "./confirmDialog.vue?vue&type=template&id=afbf4292&scoped=true"
import script from "./confirmDialog.vue?vue&type=script&lang=js"
export * from "./confirmDialog.vue?vue&type=script&lang=js"

import "./confirmDialog.vue?vue&type=style&index=0&id=afbf4292&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afbf4292"]])

export default __exports__